if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');

      // Handle customily button
      this.customilyCheckbox = this.form.querySelector('input[name="customily_product"]');
      if (this.customilyCheckbox) {
        this.customilyCheckbox.addEventListener('change', this.onCustomilyChange.bind(this));
      }
    }

    onCustomilyChange(evt) {
      this.submitCustomilyButton = this.querySelector('[id="customily-cart-btn"]');

      if (evt.target.checked) {
        this.submitCustomilyButton.classList.remove('disabled');
        this.submitCustomilyButton.removeAttribute('disabled');
      } else {
        this.submitCustomilyButton.classList.add('disabled');
        this.submitCustomilyButton.setAttribute('disabled', 'disabled');
      }
    }

    async onSubmitHandler(evt) {

      try {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // return when personalisation or badge input is not empty so we can handle the submit in PersonalisationProductDetailTool.js
        if(this.submitButton.classList.contains('is-personalised-product')) {
          const propertyPrint = this.form.querySelector('.field_personalisation');
          const propertyBadge = this.form.querySelector('.field_badge');

          if(propertyPrint.value !== '' || propertyBadge.value !== '') {
            return
          }
        }

        this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        const response = await fetch(routes.cart_add_url, config)
        const data = await response.json()

        if (data.status) {
          this.handleErrorMessage(data.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        }

        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { this.cartNotification.renderContents(data) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cartNotification.renderContents(data);
        }

          const responseCartPage =  await fetch(`${window.location.origin}/cart`)
          const html = await responseCartPage.text()
          const div = document.createElement("div");
          div.innerHTML = html;


      } catch (e) {
        console.error(e);

      } finally {
        this.submitButton.classList.remove('loading');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }


    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
